import { render, staticRenderFns } from "./StudentCertificateManage.vue?vue&type=template&id=4850b518&scoped=true"
import script from "./StudentCertificateManage.vue?vue&type=script&lang=js"
export * from "./StudentCertificateManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850b518",
  null
  
)

export default component.exports